// AI 难度配置 — 六档限时迭代加深参数 (depth / QS / TT / noise)
// 参考文档:
//   - 深度对强度: https://www.chessprogramming.org/Depth
//   - QS on/off: https://www.chessprogramming.org/Quiescence_Search
//   - TT on/off: https://www.chessprogramming.org/Transposition_Table
//   - Selectivity (随机/blunder): https://www.chessprogramming.org/Selectivity

import { SearchOptions } from './search';

export type Level =
  | 'beginner'
  | 'intermediate'
  | 'advanced'
  | 'nascentSoul'
  | 'spiritSevering'
  | 'ascendant';

export interface LevelConfig extends SearchOptions {
  minTimeMs: number;
  jitterRatio: number;
  noise: number;   // 评分噪声 σ (0 = 确定性)
  topN: number;    // 从前 N 个最优走子中随机选 (topN=1 = 确定性)
}

export const LEVELS: Record<Level, LevelConfig> = {
  beginner:       { maxDepth: 2,  useQS: true,  useTT: false, minTimeMs: 150,   timeMs: 300,    jitterRatio: 0.1, noise: 80, topN: 3 },
  intermediate:   { maxDepth: 4,  useQS: true,  useTT: true,  minTimeMs: 600,   timeMs: 1_500,  jitterRatio: 0.1, noise: 0,  topN: 1 },
  advanced:       { maxDepth: 6,  useQS: true,  useTT: true,  minTimeMs: 1_200, timeMs: 4_000,  jitterRatio: 0.1, noise: 0,  topN: 1 },
  nascentSoul:    { maxDepth: 7,  useQS: true,  useTT: true,  minTimeMs: 2_000, timeMs: 8_000,  jitterRatio: 0.1, noise: 0,  topN: 1 },
  spiritSevering: { maxDepth: 8,  useQS: true,  useTT: true,  minTimeMs: 3_000, timeMs: 15_000, jitterRatio: 0.1, noise: 0,  topN: 1 },
  ascendant:      { maxDepth: 10, useQS: true,  useTT: true,  minTimeMs: 4_000, timeMs: 25_000, jitterRatio: 0.1, noise: 0,  topN: 1 },
};
